import { defineComponent as _defineComponent } from 'vue'
import { onServerPrefetch, shallowRef, useState } from '#imports'

export default /*#__PURE__*/_defineComponent({
  __name: 'GlampingPopularSearches',
  setup(__props) {

const popularSearches = useState('popularSearches', () =>
  shallowRef({ deep: 'not reactive' }),
)
onServerPrefetch(async () => {
  // eslint-disable-next-line no-undef
  const results = await $fetch('/api/glampingPopularSearch')
  popularSearches.value = results.popularSearches
})

return { __sfc: true,popularSearches }
}

})